'use strict';

import Vue from 'vue';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { Plugin } from 'vue-fragment';

import { loadComponent } from './utils/load-component';
import { transform } from '../utils/cloudinary';

Vue.use(Plugin);

Vue.mixin({
    methods: {
        srcString: (image, width, height) => {
            return transform(image, { width, height, gravity: 'auto'});
        },

        srcSetString: (image, ...dimensions) => {
            return dimensions.map(([width, height, query]) => {
                return `${transform(image, { width, height, gravity: 'auto' })} ${query}`;
            }).join(', ');
        },
    },
})

import './concert';
import './digital-panel';
import './package-panel-list';
import './package-panel-item';
import './digital-events-list';
import './subscription-list';
import './package-scroller';
import './orchestra-ensemble';
import './search-results';
import './performance-list';
import './digital-calendar-scroller';
import './calendar-filter';
import './calendar-list';
import './calendar-popup';
import './date-selector';
import './digital-concert';
import './user-details';
import './digital-archive-search';
import './digital-archive-filter';
import './your-purchases';
import './is-purchased';
import './digital-subscription';
import './digital-header';
import './digital-calendar-list';
import './composers-alphabet';
import './date-picker';

loadComponent('collapse-transition', CollapseTransition);

if (window && !window.usePrototypeWidgets) {
    window.pageWidget = new Vue({ el: '#widget-bootstrap' })
}
